import { render, staticRenderFns } from "./dharma.vue?vue&type=template&id=2edff4a2&scoped=true"
import script from "./dharma.vue?vue&type=script&lang=js"
export * from "./dharma.vue?vue&type=script&lang=js"
import style0 from "./dharma.vue?vue&type=style&index=0&id=2edff4a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edff4a2",
  null
  
)

export default component.exports